export interface Address {
  chain: string
  address: string
}

export interface Contact {
  id: string
  avatar: string
  name: string
  addresses: Address[]
}

export interface ContactCreateUpdate extends Omit<Contact, 'id'> {}

export interface ContactSection {
  kind: 'wallets' | 'contacts' | 'plugbook'
  contacts: Contact[]
}

export enum Chain {
  ICP = 'icp',
  BTC = 'btc',
  SOL = 'sol',
  ODIN = 'odin',
  DOGE = 'doge',
  LTC = 'ltc',
  HYPERCORE = 'hypercore',
}

export interface EVMChain {
  chainId: number
  name: string
  symbol: string
  rpcEndpoint: string
  icon?: string
  feeTokenId?: string
}

export type NFT = ICNFT | BTCNFT

export interface ICNFT {
  standard: 'EXT' | 'ICRC7' | 'ICPUNKS' | 'DIP721'
  id?: string
  index: number
  url: string
  collection: string
}

export interface BTCNFT {
  id: string
  standard: 'ordinal'
  txId: string
  mintIndex: number
  name: string
  metadata?: Record<string, string>
  number: number
  address: string
  contentType?: string
  satRarity?: string
  genesisTimestamp?: number
  url: string
  collection: string
}

export interface NFTCollection {
  canisterId: string
  name: string
  icon?: string
  description?: string
  nfts: NFT[]
  chain: Chain
}

export interface SNS {
  symbol: string
  indexCanisterId: string
  rootCanisterId?: string
  ledgerCanisterId: string
  governanceCanisterId?: string
}

export interface TokenPrice {
  symbol: string
  price: number
}

export interface Network {
  id: string
  name: string
  hostUrl: string
}

export type AnalyticsProvider = 'ledgerscanner' | 'phantom' | 'odin'
export type PriceProvider = 'icpswap' | 'coingecko' | 'odin'

export interface AnalyticsDetails {
  analyticsProvider?: AnalyticsProvider
  analyticsId?: string
  priceProvider?: PriceProvider
  priceId?: string
}

export interface PlugTokenGroup {
  id: string
  name: string
  symbol: string
  logoUrl: string
  analyticsDetails: AnalyticsDetails
}

export interface PlugToken {
  id: string
  chain: Chain
  logo: string
  name: string
  description?: string
  address?: string
  standard: string
  symbol: string
  decimals: number
  fee: bigint
  fee_token_id?: string
  tags: string[]
  groupId?: string
  analyticsDetails: AnalyticsDetails
  additionalData: { [key: string]: string }
  evmChain?: EVMChain
  isCustom?: boolean
}

export interface ICToken extends PlugToken {
  chain: Chain.ICP
  address: string
}

export interface OdinToken extends PlugToken {
  chain: Chain.ODIN
}

export interface SolanaToken extends PlugToken {
  chain: Chain.SOL
  address: string
}

export interface EvmToken extends PlugToken {
  evmChain: EVMChain
}

export type SwapFeeItem = {
  token: PlugToken
  amount: bigint
}

export type SwapFee = {
  items: SwapFeeItem[]
}
